import {FC, useState} from 'react';
import {
  CoverageWrapper,
  CoverageBlockTopWrapper,
  CoverageBlockWrapper,
  CoverageAutoWrapper,
  CoverageManualWrapper,
  CoverageEmptyWrapper,
  CoverageBlockTitle,
  CoverageTestsBlockToggle,
  CoverageTestsBlock,
} from '@molecules/CoverageBlock.styles';
import Text from '@atoms/Text';
import {theme} from '@styles/theme';
import Tooltip from '@atoms/Tooltip';
import {ITest} from '@types';
import CoverageTestBlock from '@molecules/CoverageTestBlock';

export interface CoverageBlockProps {
  autoCoverage?: number;
  manualCoverage?: number;
  tests?: ITest[];
  forTable?: boolean;
  tooltipOnTop?: boolean;
  chartWidth?: string;
}

const CoverageBlock: FC<CoverageBlockProps> = ({
  autoCoverage = 0,
  manualCoverage = 0,
  tests = [],
  forTable = false,
  tooltipOnTop = false,
  chartWidth = '100%',
}) => {
  const [showAutoTooltip, setShowAutoTooltip] = useState(false);
  const [showManualTooltip, setShowManualTooltip] = useState(false);
  const [showEmptyTooltip, setShowEmptyTooltip] = useState(false);
  const [showTestsCoverage, setShowTestsCoverage] = useState(false);
  const emptyCoverage = 100 - autoCoverage - manualCoverage;
  const fullCoverage = autoCoverage + manualCoverage;
  return (
    <CoverageBlockWrapper>
      {!forTable && (
        <CoverageBlockTopWrapper chartWidth={chartWidth}>
          <CoverageBlockTitle>
            <Text text="Общее покрытие" type="tinyR" color={theme.colors.basic02} />
            {!!tests.length && (
              <CoverageTestsBlockToggle
                onClick={() => setShowTestsCoverage(!showTestsCoverage)}>
                <Text
                  text={
                    showTestsCoverage
                      ? 'Скрыть разбивку по тестам'
                      : 'Показать разбивку по тестам'
                  }
                  type="tinyR"
                  color={theme.colors.accent00}
                />
              </CoverageTestsBlockToggle>
            )}
          </CoverageBlockTitle>
          <Text text={`${fullCoverage.toFixed(2).replace('.', ',')}%`} type="tinyNum" />
        </CoverageBlockTopWrapper>
      )}
      <CoverageWrapper forTable={forTable} chartWidth={chartWidth}>
        <CoverageAutoWrapper
          width={autoCoverage}
          onMouseEnter={() => setShowAutoTooltip(true)}
          onMouseLeave={() => setShowAutoTooltip(false)}>
          <Tooltip
            isVisible={showAutoTooltip}
            text={`Авто ${autoCoverage}%`}
            displayOnTop={tooltipOnTop}
          />
        </CoverageAutoWrapper>
        <CoverageManualWrapper
          width={manualCoverage}
          autoWidth={autoCoverage}
          emptyWidth={emptyCoverage}
          onMouseEnter={() => setShowManualTooltip(true)}
          onMouseLeave={() => setShowManualTooltip(false)}>
          <Tooltip
            isVisible={showManualTooltip}
            text={`Ручное ${manualCoverage}%`}
            displayOnTop={tooltipOnTop}
          />
        </CoverageManualWrapper>
        <CoverageEmptyWrapper
          width={emptyCoverage}
          onMouseEnter={() => setShowEmptyTooltip(true)}
          onMouseLeave={() => setShowEmptyTooltip(false)}>
          <Tooltip
            isVisible={showEmptyTooltip}
            text={`Не покрыто ${emptyCoverage}%`}
            displayOnTop={tooltipOnTop}
          />
        </CoverageEmptyWrapper>
      </CoverageWrapper>
      {!!tests.length && (
        <CoverageTestsBlock show={showTestsCoverage}>
          {tests.map(test => {
            return <CoverageTestBlock key={`coverage-test-${test.id}`} test={test} />;
          })}
        </CoverageTestsBlock>
      )}
    </CoverageBlockWrapper>
  );
};

export default CoverageBlock;
